import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  identifierId: null,
  accessToken: null,
  refreshToken: null,
  expiresAt: null,
  userProfile: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIdentifier(state, action) {
      state.identifierId = action.payload;
    },
    setTokens(state, action) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.expiresAt = action.payload.expiresAt;
    },
    setUserProfile(state,action) {
      state.userProfile = action.payload.userProfile;
    },
  },
});

export const { setIdentifier, setTokens, setUserProfile } = authSlice.actions;
export default authSlice.reducer;
